export function mainNavHamburger() {
  /**
   * Main nav add hamburger
   * FIXME: This some ugly piece of code right here
   */
  if (document.querySelector(".side-nav a")) {
    let hamburger = document.createElement("button");
    hamburger.classList.add("hamburger", "hamburger--criss-cross");
    hamburger.innerHTML =
      '<div class="inner">' +
      '        <span class="bar"></span>' +
      '        <span class="bar"></span>' +
      '        <span class="bar"></span>' +
      "    </div>";

    hamburger.addEventListener("click", (e) => {
      e.target.closest(".side-nav").classList.toggle("open");
      e.target.closest(".hamburger").classList.toggle("active");
    });

    document.querySelector(".side-nav > a").innerHTML = "";

    document.querySelector(".side-nav > a").appendChild(hamburger);
  }
}
